module.exports = __webpack_public_path__ + "static/logo-2ca18cf59ec1290cd968484a0eedb022.png";